<template>
  <div class="app-container">
    <!-- 主要内容区域 -->
    <div class="main-content">
      <div class="bgk-img">
        <img src="https://www.hketang.cn/_nuxt/img/course-banner.2811f9b.png" alt="" />
      </div>
      <div class="tabs-box">
        <div class="tabs">
          <div
            class="left"
            @click="tabschange(1)"
            :class="tabsactive == 1 ? 'active' : ''"
          >
            平面设计
          </div>
          <div
            class="right"
            @click="tabschange(2)"
            :class="tabsactive == 2 ? 'active' : ''"
          >
            插画设计
          </div>
        </div>
        <div class="listbox">
          <div
            class="card"
            v-for="(item, i) in workslist"
            :key="i"
            @click="handledetal(item)"
          >
            <img :src="item.pictureUrl" alt="" />
            <div class="info-box">
              <div class="name">{{ item.title }}</div>
              <div class="type">{{ item.worksType }}</div>
              <div class="date">{{ item.createTime }}</div>
            </div>
          </div>
          <div style="width: 268px"></div>
          <div style="width: 268px"></div>
          <div style="width: 268px"></div>
          <el-pagination
            style="text-align: right"
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="pageSize"
            :current-page="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
      <indetails
        :dialogTableVisible.sync="dialogTableVisible"
        :id="selectedId"
      ></indetails>
    </div>
  </div>
</template>

<script>
import { getworks } from "@/api/index.js";
import indetails from "./details.vue";

export default {
  name: "production",
  components: { indetails },
  data() {
    return {
      tabsactive: 1,
      currentPage: 1,
      pageSize: 12,
      total: 0,
      workslist: [],
      dialogTableVisible: false,
      selectedId: null,
    };
  },
  created() {
    this.getworks();
  },
  methods: {
    tabschange(val) {
      this.tabsactive = val;
      this.currentPage = 1; // 切换类型时重置页码
      this.getworks();
    },
    getworks() {
      // 作品类型映射：1-平面设计(0), 2-插画设计(1)
      let worksTypeMap = {
        1: "1", // 平面设计
        2: "2", // 插画设计
      };
      
      getworks({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        worksType: worksTypeMap[this.tabsactive],
      }).then((res) => {
        if (res.data && res.data.list) {
          this.workslist = res.data.list;
          this.total = res.data.total || 0;
        } else {
          this.workslist = [];
          this.total = 0;
        }
      }).catch(error => {
        console.error('获取作品失败:', error);
        this.workslist = [];
        this.total = 0;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 改变页面大小时重置页码
      this.getworks();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getworks();
    },
    handledetal(val) {
      this.selectedId = val.id;
      this.dialogTableVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
.app-container {
  padding: 0;
  margin: 0;
  font-family: "Microsoft YaHei";

  color: #333;
  overflow: hidden;
  clear: both;
  .main-content {
    .bgk-img {
      width: 100%;
      height: 210px;
      z-index: 2;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .tabs-box {
      width: 100%;
      font-size: 18px;
      background-color: #f5f6f9;
      padding: 0 0 60px 0;
      .tabs {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        margin-top: -30px;

        .left {
          width: 300px;
          height: 74px;
          background: #f5f6f9;
          font-weight: 500;
          color: #2d3341;
          line-height: 74px;
          border-top-left-radius: 20px;
          cursor: pointer;
        }
        .right {
          width: 300px;
          height: 74px;
          background: #f5f6f9;
          font-weight: 500;
          color: #2d3341;
          line-height: 74px;
          border-top-right-radius: 20px;
          cursor: pointer;
        }
        .active {
          background: #fff;
          padding: 20px 0 0 0;
          margin-top: -20px;
          border-top-right-radius: 20px;
          border-top-left-radius: 20px;
        }
      }
      .listbox {
        width: 1140px;
        margin: 0 auto;
        background: #fff;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 30px;
        .card {
          width: 268px;
          border-radius: 10px;
          overflow: hidden;
          border: 1px solid #ebeef5;
          margin-bottom: 35px;
          cursor: pointer;
          box-shadow: 0 0 10px #ebeef5;
          img {
            width: 268px;
            height: 180px;
            object-fit: cover;
          }

          .info-box {
            padding: 15px 10px;

            .name {
              font-size: 16px;
              font-family: "Microsoft YaHei";
              font-weight: 500;
              color: #303133;
              margin: 0 0 12px;
              text-align: left;
            }

            .type {
              font-size: 16px;
              color: #838a9d;
              margin: 0 0 20px;
              font-family: "Microsoft YaHei";
              font-weight: 400;
              text-align: left;
            }

            .date {
              text-align: right;
              font-size: 18px;
              color: #838a9d;
              font-weight: 400;
              font-family: "Microsoft YaHei";
            }
          }
          &:hover .card {
            box-shadow: 0 0 10px #ebeef5;
          }
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .app-container .main-content .tabs-box .tabs {
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
  }
  .app-container .main-content .tabs-box .listbox {
    width: 100%;
    padding: 16px;
    box-sizing: border-box;
  }
}

@media (max-width: 992px) {
  .app-container .main-content .tabs-box .tabs .left,
  .app-container .main-content .tabs-box .tabs .right {
    width: 50%;
  }
  .app-container .main-content .tabs-box .listbox .card {
    width: calc(50% - 8px);
  }
  .app-container .main-content .tabs-box .listbox .card img {
    width: 100%;
    height: auto;
  }
  /* 隐藏用于占位的固定宽度列，避免移动端产生横向滚动 */
  .app-container .main-content .tabs-box .listbox > div[style*="width: 268px"] {
    display: none !important;
  }
}

@media (max-width: 600px) {
  .app-container .main-content .tabs-box .listbox {
    padding: 12px;
  }
  .app-container .main-content .tabs-box .listbox .card {
    width: 100%;
  }
}
</style>
